import React from "react";

import { Divider, SelectChangeEvent, Stack } from "@mui/material";

import type { SettingsModuleProps } from "@app/analytics/account/types";
import WorkspaceSettingsAccordion from "@app/analytics/account/WorkspaceSettings/components/WorkspaceSettingsAccordion";
import type { EnterpriseWorkspaceSettings } from "@app/common/workspaces/types";

import DistributionSettings from "./DistributionSettings";
import GeneralSettings from "./GeneralSettings";
import ReportSharingSettings from "./ReportSharingSettings";

const ReportingModule = ({
  settings,
  onSettingUpdate,
  workspaceIsInactive,
}: SettingsModuleProps) => {
  const handleDropdownChange = (
    settingValue: boolean,
    settingName: keyof EnterpriseWorkspaceSettings
  ) => {
    onSettingUpdate({ [settingName]: settingValue });
  };

  const handlePreferenceChange =
    (
      preferenceName: keyof typeof settings,
      type: "toggle" | "value" = "value"
    ) =>
    (event: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent) => {
      onSettingUpdate({
        [preferenceName]:
          type === "toggle"
            ? (event.target as HTMLInputElement).checked
            : event.target.value,
      });
    };

  return (
    <WorkspaceSettingsAccordion
      title="Reporting"
      subtitle="Customize access to metrics, downloads, integrations, report sharing, and distribution"
    >
      <GeneralSettings
        onDropdownChange={handleDropdownChange}
        onPreferenceChange={handlePreferenceChange}
        settings={settings}
        workspaceIsInactive={workspaceIsInactive}
      />
      <Divider />
      <ReportSharingSettings
        onDropdownChange={handleDropdownChange}
        onPreferenceChange={handlePreferenceChange}
        settings={settings}
        workspaceIsInactive={workspaceIsInactive}
      />
      <Divider />
      <DistributionSettings
        onDropdownChange={handleDropdownChange}
        onPreferenceChange={handlePreferenceChange}
        onSettingUpdate={onSettingUpdate}
        settings={settings}
        workspaceIsInactive={workspaceIsInactive}
      />
      <Stack /> {/* shim for spacing */}
    </WorkspaceSettingsAccordion>
  );
};

export default ReportingModule;
